import ChartGroup from './ChartGroup';

export interface ICustomReport {
  id: string;
  groups: ChartGroup[];
}

class CustomReport {
  public readonly id: string;
  public readonly groups: ChartGroup[];

  constructor({ id, groups }: { id: string; groups: ChartGroup[] }) {
    this.id = id;
    this.groups = groups;
  }

  public toJSON = () => ({
    id: this.id,
    groups: this.groups,
  });

  public static fromJSON = (json: ICustomReport): CustomReport => {
    const { id, groups } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    const _groups = groups ? groups.map((item) => ChartGroup.fromJSON(item)) : undefined;
    if (_groups === undefined) {
      throw new Error('.groups must be an array');
    }

    return new CustomReport({
      id,
      groups: _groups,
    });
  };
}

export default CustomReport;
